module.exports = __webpack_public_path__ + "static/media/part.dce32e60.svg";